import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76a7199a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "权限菜单" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formState,
        rules: _ctx.rules,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            ref: "title",
            label: "角色名称",
            name: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
                placeholder: "请输入菜单名称"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "type",
            label: "角色简介",
            name: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.desc,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.desc) = $event)),
                placeholder: "请输入角色简介"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "pid",
            label: "权限配置",
            name: "pid"
          }, {
            default: _withCtx(() => [
              (_ctx.allMenu && _ctx.allMenu.length)
                ? (_openBlock(), _createBlock(_component_a_tree, {
                    key: 0,
                    selectedKeys: _ctx.selectedKeys,
                    "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedKeys) = $event)),
                    expandedKeys: _ctx.expandedKeys,
                    "onUpdate:expandedKeys": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.expandedKeys) = $event)),
                    checkedKeys: _ctx.formState.auth_ids,
                    "onUpdate:checkedKeys": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.auth_ids) = $event)),
                    checkable: "",
                    "default-expand-all": "",
                    "auto-expand-parent": true,
                    checkStrictly: true,
                    onSelect: _ctx.onSelect,
                    onCheck: _ctx.onSelect,
                    "tree-data": _ctx.allMenu,
                    replaceFields: {children:'sub', title:'title', key:'id'}
                  }, null, 8, ["selectedKeys", "expandedKeys", "checkedKeys", "onSelect", "onCheck", "tree-data"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            "wrapper-col": { span: 14, offset: 4 },
            style: {"margin-top":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onSubmit,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: _ctx.goBack,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "label-col", "wrapper-col"])
    ]),
    _: 1
  }))
}